package com.essntl.features.itinerary.ui.edit_itinerary

import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.file.domain.model.FileModel
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.servicesToConfirmText
import com.essntl.features.itinerary.domain.model.ItineraryServiceFilterOptions
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.message.domain.model.MessageModel
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.request.domain.model.RequestModel
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.features.travelagent.domain.model.TravelAgentModel
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

data class EditItineraryState(
    // Concierge
    val startDate: LocalDate = Clock.System.now().toLocalDateTime(TimeZone.UTC).date,
    val selectedFromDate: String? = null,
    val selectedToDate: String? = null,

    // Itinerary service
    val getAllItinerary: State<List<ItineraryModel>> = State(),
    val editProposal: State<ProposalModel> = State(),
    val loadingServiceIds: Set<String> = emptySet(),
    val getAllItineraryService: State<List<ItineraryServiceModel>> = State(),
    val filterOptions: ItineraryServiceFilterOptions = ItineraryServiceFilterOptions(),
    val addItineraryService: State<ItineraryServiceModel> = State(),
    val selectedItineraryServiceIds: Set<String> = emptySet(),
    val clickedItineraryServiceId: String? = null,
    val updateItineraryServiceLoading: Set<String> = emptySet(),
    val getCoverImage: State<FileModel> = State(),

    // Request
    val getAllRequest: State<List<RequestModel>> = State(),
    val addEditRequest: State<RequestModel> = State(),

    // Proposal
    val addEditProposal: State<ProposalModel> = State(),

    // Category
    val getAllCategory: State<List<CategoryModel>> = State(),

    // Area
    val getAllArea: State<List<AreaModel>> = State(),

    // Client
    val getAllClient: State<List<ClientModel>> = State(),

    // Task
    val getAllItineraryTask: State<List<TaskModel>> = State(),
    val getAllItineraryServiceTask: State<List<TaskModel>> = State(),
    val updateTaskLoading: Set<String> = emptySet(),
    val deleteTaskLoading: Set<String> = emptySet(),

    // Message
    val sendMessageList: State<Unit> = State(),
    val getAllMessages: State<List<MessageModel>> = State(),
    val checkContact: State<Unit> = State(),
    val sendContact: State<Unit> = State(),

    // Profile
    val getProfile: State<ProfileModel> = State(),

    // Travel Agent
    val getAllTravelAgent: PaginationState<TravelAgentModel> = PaginationState(),
) {
    val isLoading
        get() = getAllItineraryService.isLoading

    private val itineraryServices = getAllItineraryService.data.orEmpty()
    val notConfirmedServices = itineraryServices.filter {
        it.status != ItineraryServiceModel.Status.Confirmed &&
            it.status != ItineraryServiceModel.Status.Cancelled
    }

    val itineraryTitle
        get() = getAllItinerary.data.orEmpty().firstOrNull()?.proposal?.title ?: ""

    private val itineraryModel
        get() = getAllItinerary.data.orEmpty().firstOrNull()

    val servicesToConfirmTitle
        get() = if (notConfirmedServices.isNotEmpty()) {
            "${notConfirmedServices.count()} services to confirm"
        } else {
            "All services confirmed"
        }

    val confirmedServicesText
        get() = itineraryModel?.servicesToConfirmText(itineraryServices) ?: ""
}